function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.469 11h-.563a.281.281 0 00-.281.281v7.031a.562.562 0 01-.563.563H4.688a.563.563 0 01-.562-.563V5.938a.563.563 0 01.563-.562h7.03A.281.281 0 0012 5.094V4.53a.281.281 0 00-.281-.281H4.688A1.687 1.687 0 003 5.938v12.375A1.687 1.687 0 004.688 20h12.375a1.687 1.687 0 001.687-1.688v-7.03a.281.281 0 00-.281-.282zm2.11-9l-4.782.012a.422.422 0 00-.422.422v.351a.422.422 0 00.422.422l3.164-.012.024.025L7.623 14.581a.422.422 0 000 .598l.2.199a.422.422 0 00.597 0L19.78 4.016l.025.024-.012 3.165a.422.422 0 00.422.421h.351a.422.422 0 00.422-.421L21 2.422A.422.422 0 0020.578 2z",
  fill: "#246A73"
});
function SvgNewWindowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgNewWindowIcon;